exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group.required .control-label:after {\n  content:\"*\";\n  color:red;\n  margin-left: 3px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/track-edit/track-edit.component.css
// module id = ../../../../../src/app/track-edit/track-edit.component.css
// module chunks = main